import modalActions from "actions/modal";
import cn from "classnames";
import BookForm from "components/shared/book/form";
import { FilesField } from "components/shared/form";
import Loader from "components/shared/loader";
import { dateTimeToView } from "helpers/date";
import { generatedActions } from "helpers/redux";
import { ymEvent } from "helpers/system";
import { requiredField } from "helpers/validators";
import React from "react";
import { connect } from "react-redux";
import { apply, uploadFile } from "sources/books/expenses";
import { resourceEnum } from "./constants";
import { config, initialState } from "./formConfig";

class Form extends BookForm {
    applyReq = async (serialized) => {
        const copySerialized = { ...serialized };

        delete copySerialized.files;
        delete copySerialized.resource;

        if (copySerialized.periodType) {
            copySerialized.period = Number(copySerialized.period);
        }

        copySerialized.value = Number(copySerialized.value);
        copySerialized.date = dateTimeToView(copySerialized.date, "YYYY-MM-DD");

        const response = await apply(copySerialized);

        if (response) {
            ymEvent("SaveAnExpense");
            this.close();
        } else {
            this.setState({ isLoading: false, isValid: false });
        }
    };

    renderResource = () => {
        const { config } = this.props;
        const { resource } = this.state;

        if (!resource) {
            return null;
        }

        const configByResource = {
            [resourceEnum.CAR]: config.carId,
            [resourceEnum.TRAILER]: config.trailerId,
            [resourceEnum.DRIVER]: config.driverId,
        };

        return this.renderSelect({ ...configByResource[resource], validators: [requiredField], required: true });
    };

    renderFiles = () => (
        <FilesField
            isMultiple
            withoutDownload
            uploadFile={uploadFile}
            modal={this.props.addModal}
            files={this.state.files}
            onChange={(files) => this.setState({ files, fileIds: files.map((file) => file.id) })}
        />
    );

    render() {
        const { config } = this.props;
        const { isValid, isLoading, periodType } = this.state;

        if (isLoading) {
            return (
                <div className="loader-wrap">
                    <Loader prefix="absolute-center" />
                </div>
            );
        }

        const cname = cn("book-form__body", { "book-form__body--invalid": !isValid });

        return (
            <form className={cname} onSubmit={this.onSubmit}>
                {this.renderSelect(config.resource)}
                {this.renderResource()}
                {this.renderSelect(config.periodType)}
                {periodType && this.renderField({ ...config.period, validators: [requiredField], required: true })}
                {this.renderSelect(config.typeId)}
                {this.renderDateField(config.date)}
                {this.renderField(config.value)}
                {this.renderField(config.comment)}
                {this.renderFiles()}
                <div className="mt-3 float-right">
                    <div className="btn btn-sm btn-secondary mr-2" onClick={this.props.back}>
                        Отмена
                    </div>
                    <input type="submit" className="btn btn-sm btn-brand" value="Сохранить" />
                </div>
            </form>
        );
    }
}

const ConfiguredModal = (props) => {
    return <Form {...props} config={config} initialState={{ ...initialState, ...props.formData }} />;
};

const container = (Component) => {
    const mapState = (state) => ({
        enums: state.dictionaries.enums,
    });

    const mapDispatch = (dispatch) => ({
        addModal: (params) => dispatch(modalActions.add(params)),
        mergeParams: (params) => dispatch(generatedActions.expenses.merge(params)),
    });

    return connect(mapState, mapDispatch)(Component);
};

export default container(ConfiguredModal);
